import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";

const linkCls = "hidden text-sm font-medium text-[#0f172a] hover:text-[#2563eb] md:inline";

export const Navbar = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-50 border-b border-slate-200/80 bg-white/85 backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
        <Logo />
        <nav className="flex items-center gap-6">
          <a href="#come-funziona" data-testid="nav-link-come-funziona" className={linkCls} style={{ transition: "color 160ms" }}>
            Come Funziona
          </a>
          <a href="#garanzie" data-testid="nav-link-gdpr" className={linkCls} style={{ transition: "color 160ms" }}>
            Conformità GDPR
          </a>
          <button data-testid="nav-button-accedi" className="btn-primary" onClick={() => navigate(user ? "/app" : "/accedi")}>
            {user ? "Vai alla WebApp" : "Accedi alla WebApp"}
            <ArrowRight className="h-4 w-4" />
          </button>
        </nav>
      </div>
    </header>
  );
};
